"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var ListingList_1 = require("./ListingList");
var SearchBox_1 = require("office-ui-fabric-react/lib/SearchBox");
var ListingListPage_styles_1 = require("./ListingListPage.styles");
var ListingListPage_classNames_1 = require("./ListingListPage.classNames");
var ListingTile_1 = require("./ListingTile");
var ListingListSearchInput = /** @class */ (function (_super) {
    __extends(ListingListSearchInput, _super);
    function ListingListSearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onSearchChange = function (newValue) {
            _this.props.listings.setSearchText(newValue);
        };
        return _this;
    }
    ListingListSearchInput.prototype.render = function () {
        return React.createElement(SearchBox_1.SearchBox, { value: this.props.listings.searchText, onChange: this._onSearchChange });
    };
    ListingListSearchInput = __decorate([
        mobx_react_1.observer
    ], ListingListSearchInput);
    return ListingListSearchInput;
}(React.Component));
var ListingListPage = /** @class */ (function (_super) {
    __extends(ListingListPage, _super);
    function ListingListPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderItem = function (listing, idx, props) {
            return React.createElement(ListingTile_1.ListingTile, { key: listing.id, listing: listing, onClick: props.onSelectItem, onLoad: _this.props.onLoad, onOpen: _this.props.onOpen });
        };
        return _this;
    }
    ListingListPage.prototype.render = function () {
        var classNames = ListingListPage_classNames_1.getClassNames(ListingListPage_styles_1.getStyles(undefined, this.props.styles), this.props.className);
        return (React.createElement("div", { className: classNames.root },
            React.createElement("div", { className: classNames.header },
                React.createElement(ListingListSearchInput, __assign({}, this.props))),
            React.createElement("div", { className: classNames.body },
                React.createElement(ListingList_1.ListingListContainer, __assign({}, this.props, { onRenderListing: this._onRenderItem })))));
    };
    return ListingListPage;
}(React.Component));
exports.ListingListPage = ListingListPage;
